module.exports = __webpack_public_path__ + "static/media/Bunny Suit Guy.5ea860ea.jpg";